/**
 * Polish plural-form selection: a count picks one of three noun forms —
 * one (1), few (2–4, except the 12–14 teens), many (everything else).
 * e.g. plForm(1,'marka','marki','marek') → marka; plForm(15,…) → marek.
 */
export function plForm(n: number, one: string, few: string, many: string): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (n === 1) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few;
  return many;
}

const PREPARAT = ['preparat', 'preparaty', 'preparatów'] as const;

/** "preparat" agreeing with a count that stands alone ("86 preparatów"). */
export function preparatLabel(n: number): string {
  return plForm(n, ...PREPARAT);
}

/**
 * "preparat" inside a partitive "N z M …" frame. Polish "z" governs the
 * genitive, so the noun is genitive plural whatever M is — "2 z 3 preparatów",
 * never "2 z 3 preparaty".
 */
export const PREPARAT_PARTITIVE = PREPARAT[2];
